import harvard_logo from '../assets/harvard.jpg'
import diplomma_logo from '../assets/diplomma.webp'
export const certifications = [
    {
        id:1,
        name:'CS50X',
        link:'https://cs50.harvard.edu/certificates/8b8fd4d1-32b1-446f-8dcc-351d701d8700',
        year:'2022',
        logo: harvard_logo
    },
    {
        id:2,
        name:'Mathematics Diplomma',
        year:'2012',
        logo:diplomma_logo
    },
]